"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doSearch = exports.parseSearch = exports.doSearchBox = exports.getSuggestedViewport = exports.setBoundsToInclude = exports.mapOptions = exports.findLocations = exports.getDistance = void 0;
// https://cloud.google.com/blog/products/maps-platform/how-calculate-distances-map-maps-javascript-api
const getDistance = (mk1, mk2) => {
    var R = 6371.071; // Radius of the Earth in km
    var rlat1 = mk1.lat * (Math.PI / 180); // Convert degrees to radians
    var rlat2 = mk2.lat * (Math.PI / 180); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = (mk2.lng - mk1.lng) * (Math.PI / 180); // Radian difference (longitudes)
    var d = 2 *
        R *
        Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
                Math.cos(rlat2) *
                Math.sin(difflon / 2) *
                Math.sin(difflon / 2)));
    return d;
};
exports.getDistance = getDistance;
const findLocations = function (locations, currentLocation) {
    const listToReturn = locations
        .map((location) => (Object.assign(Object.assign({}, location), { distanceFromStartingPoint: (0, exports.getDistance)(currentLocation, {
            lat: location.lat,
            lng: location.lng,
        }) })))
        .sort((a, b) => a.distanceFromStartingPoint - b.distanceFromStartingPoint)
        .map((location, i) => (Object.assign(Object.assign({}, location), { listIndex: i + 1 })));
    //handle when nothing in 30 km radius. return the next neareast one..
    return listToReturn;
};
exports.findLocations = findLocations;
exports.mapOptions = {
    mapId: "961365a28e6466b3",
    minZoom: 3,
    disableDefaultUI: true,
    zoomControl: true,
    restriction: {
        latLngBounds: {
            north: 56.8593635,
            south: 41.6765556,
            east: -74.3201062,
            west: -95.1537399,
        },
        strictBounds: false,
    },
};
const setBoundsToInclude = ({ lat, lng }, mapRef, currentLocation, suggestedViewport = true) => {
    var _a, _b, _c, _d;
    if (!((_b = (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.getBounds()) === null || _b === void 0 ? void 0 : _b.contains({ lat, lng }))) {
        const bounds = ((_c = (suggestedViewport ? (0, exports.getSuggestedViewport)(currentLocation) : undefined)) !== null && _c !== void 0 ? _c : new google.maps.LatLngBounds())
            .extend({
            lat,
            lng,
        })
            .extend({
            lat: currentLocation.lat,
            lng: currentLocation.lng,
        });
        (_d = mapRef.current) === null || _d === void 0 ? void 0 : _d.fitBounds(bounds);
    }
};
exports.setBoundsToInclude = setBoundsToInclude;
const getSuggestedViewport = (currentLocation) => {
    if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.viewport) {
        return new google.maps.LatLngBounds({
            lat: currentLocation.viewport.south,
            lng: currentLocation.viewport.west,
        }, {
            lat: currentLocation.viewport.north,
            lng: currentLocation.viewport.east,
        });
    }
};
exports.getSuggestedViewport = getSuggestedViewport;
//Main search box
const doSearchBox = (location, t, searchParams) => {
    if (location === undefined) {
        return;
    }
    const params = {};
    if (searchParams) {
        for (const [key, value] of searchParams) {
            params[key] = value;
        }
    }
    const v = location.viewport;
    const locParams = {
        n: location.name,
        lat: location.lat.toString(),
        lng: location.lng.toString(),
        b: window.location.href
    };
    if (v) {
        locParams["v"] = [v === null || v === void 0 ? void 0 : v.south, v === null || v === void 0 ? void 0 : v.east, v === null || v === void 0 ? void 0 : v.north, v === null || v === void 0 ? void 0 : v.west].filter((x) => x !== undefined).join("|");
    }
    Object.assign(params, locParams);
    window.location.href = `${window.location.hostname === "localhost"
        ? "http://localhost:8000" :
        window.location.hostname === "edit.ontario.ca"
            ? "https://www.ontario.ca"
            : ""}${t("searchBox.redirectURL")}?${new URLSearchParams(Object.assign({}, params))}`;
};
exports.doSearchBox = doSearchBox;
//Returns physical location search params as a CurrentLocation
const parseSearch = (search) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const s = new URLSearchParams(search);
    const name = (_a = s.get("n")) !== null && _a !== void 0 ? _a : "???";
    const lat = parseFloat((_b = s.get("lat")) !== null && _b !== void 0 ? _b : "");
    const lng = parseFloat((_c = s.get("lng")) !== null && _c !== void 0 ? _c : "");
    const viewportCoords = (_e = (_d = s
        .get("v")) === null || _d === void 0 ? void 0 : _d.split("|").map((x) => parseFloat(x))) !== null && _e !== void 0 ? _e : [];
    const locationParams = {
        name,
        lat,
        lng,
        viewport: {
            south: (_f = viewportCoords[0]) !== null && _f !== void 0 ? _f : NaN,
            east: (_g = viewportCoords[1]) !== null && _g !== void 0 ? _g : NaN,
            north: (_h = viewportCoords[2]) !== null && _h !== void 0 ? _h : NaN,
            west: (_j = viewportCoords[3]) !== null && _j !== void 0 ? _j : NaN, // West longitude
        },
    };
    return locationParams;
};
exports.parseSearch = parseSearch;
//Used in location-search-query (search results map page)
const doSearch = (location, setButtonLastClickedAt, searchParams) => {
    if (location === undefined) {
        return;
    }
    setButtonLastClickedAt(Date.now());
    const params = {};
    if (searchParams) {
        for (const [key, value] of searchParams) {
            if (value && value !== '0') {
                params[key] = value;
            }
        }
    }
    const v = location.viewport;
    const locParams = {
        n: location.name,
        lat: location.lat.toString(),
        lng: location.lng.toString()
    };
    if (v) {
        locParams["v"] = [v === null || v === void 0 ? void 0 : v.south, v === null || v === void 0 ? void 0 : v.east, v === null || v === void 0 ? void 0 : v.north, v === null || v === void 0 ? void 0 : v.west].filter((x) => x !== undefined).join("|");
    }
    Object.assign(params, locParams);
    const n = `?${new URLSearchParams(Object.assign({}, params))}`;
    window.location.search = n;
};
exports.doSearch = doSearch;
